<template>
  <div class="container">
    <!-- 功能 -->
    <div class="table-container">
      <div class="table-action-row">
        <div class="table-action-form">
          <el-input
            class="form-item"
            v-model="sandBoxSearch.sandbox_name"
            clearable
            placeholder="请输入名称"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>
          <el-select
            v-model="sandBoxSearch.sandbox_type"
            clearable
            placeholder="请选择Sandbox类型"
            class="form-item"
            @change="handleChange"
          >
            <el-option
              v-for="item in sandboxTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            class="form-item"
            v-model="sandBoxSearch.sandbox_tmpl_name"
            clearable
            placeholder="请输入模版名称"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>

          <el-select
            v-model="sandBoxSearch.is_cloned"
            clearable
            placeholder="是否克隆"
            class="form-item"
            @change="handleChange"
          >
            <el-option
              v-for="item in isCloneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            class="form-item"
            v-model="sandBoxSearch.update_by"
            clearable
            placeholder="更新人"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>

          <el-date-picker
            class="form-item time_css"
            v-model="sandBoxSearch.update_time"
            type="datetimerange"
            start-placeholder="更新时间"
            end-placeholder="更新时间"
            value-format="timestamp"
            @change="handleChange"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>

          <el-button @click="handleReset">重 置</el-button>
        </div>
        <div class="table-action-button">
          <el-button
            v-if="jurisdiction.updateManage_sandbox_add"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
          >
            新增SandBox
          </el-button>
        </div>
      </div>
      <List ref="list" :request="getList" :layout="layout">
        <template v-slot:table-action>
          <el-table-column fixed="right" label="操作" width="500">
            <template slot-scope="scope">
              <el-button class="text-button" type="text" @click="toDetail(scope.row)">
                查看详情
              </el-button>
              <el-button
                v-if="jurisdiction.updateManage_sandbox_edit"
                class="text-button"
                type="text"
                @click="edit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                class="text-button"
                v-if="jurisdiction.updateManage_sandbox_refresh"
                type="text"
                @click="refreshSandbox(scope.row)"
              >
                刷新
              </el-button>
              <el-dropdown
                trigger="click"
                placement="bottom"
                v-if="
                  jurisdiction.updateManage_sandbox_clone ||
                  jurisdiction.updateManage_sandbox_delete
                "
              >
                <el-button type="text">
                  <i class="iconfont icon-more" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="!scope.row.cloned && jurisdiction.updateManage_sandbox_clone"
                    @click.native="clone(scope.row)"
                  >
                    克隆
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="jurisdiction.updateManage_sandbox_delete"
                    class="danger-action"
                    @click.native="toDelete(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </List>
      <el-dialog title="克隆沙箱" :visible.sync="cloneVisible">
        <el-form ref="cloneForm" :model="cloneSandbox" :rules="cloneRules">
          <el-form-item label="克隆沙箱名称" :label-width="'120px'" prop="name">
            <el-input v-model="cloneSandbox.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cloneVisible = false">取 消</el-button>
          <el-button type="primary" @click="toClone">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 新建和编辑 -->
      <createSandbox
        :visible="createVisible"
        @close="createVisible = false"
        :row="rowMessage"
        :operate-type="operateType"
        @refresh="refresh"
      />
      <detailSandbox
        :visible="detailVisible"
        @close="detailVisible = false"
        :row="rowMessage"
        :jurisdiction="jurisdiction"
        @editSandBox="editFromDetail"
      />
      <messageBox ref="messageBox" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '@/components/table';
import createSandbox from './sandBoxItem.vue';
import detailSandbox from './sandBoxDetail.vue';
import messageBox from '@/components/messageBox';
import { timestampToISO, isoToTimestamp, formattedDate } from '../utils/index';
import _ from 'lodash';

export default {
  components: {
    List,
    createSandbox,
    detailSandbox,
    messageBox,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: 'full', value: 'full' },
        { label: 'partial', value: 'partial' },
        { label: 'development', value: 'development' },
      ],
      isCloneOptions: [
        { label: '是', value: '2' },
        { label: '否', value: '1' },
      ],
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        sandbox_tmpl_name: '',
        is_cloned: '',
        update_by: '',
        update_time: '',
      },
      layout: [
        { name: 'sandbox_name', label: '名称' },
        { name: 'sandbox_type', label: 'Sandbox类型' },
        { name: 'sandbox_tmpl_name', label: '模版名称' },
        { name: 'is_cloned', label: '是否克隆' },
        { name: 'update_by', label: '更新人' },
        { name: 'update_time', label: '更新时间' },
        {
          name: 'desc',
          label: '描述',
        },
      ],
      // 新建窗口展示
      createVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
      cloneSandbox: {
        id: 0, // 克隆的沙箱租户ID。必录
        name: '',
      },
      cloneRules: {
        name: [
          {
            required: true,
            message: '克隆沙箱名称必填且必须为英文或英文+数字，且最多10个字符',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^(?=.*[a-zA-Z])[a-zA-Z0-9]{1,10}$/,
            message: '克隆沙箱名称必须为英文或英文+数字，且最多10个字符',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'updateManage_sandbox_add',
        'updateManage_sandbox_edit',
        'updateManage_sandbox_delete',
        'updateManage_sandbox_clone',
        'updateManage_sandbox_refresh',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      // console.log('%c Line:267 🍷 jurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },
    // 查看详情
    // toDetail
    toDetail(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      console.log('%c Line:281 🍊 this.sandBoxSearch', 'color:#ed9ec7', this.sandBoxSearch);
      const params = {};
      if (this.sandBoxSearch.sandbox_name) {
        params.sandbox_name = this.sandBoxSearch.sandbox_name;
      }
      if (this.sandBoxSearch.sandbox_type) {
        params.sandbox_type = this.sandBoxSearch.sandbox_type;
      }
      if (this.sandBoxSearch.sandbox_tmpl_name) {
        params.sandbox_tmpl_name = this.sandBoxSearch.sandbox_tmpl_name;
      }
      if (this.sandBoxSearch.is_cloned) {
        params.is_cloned = this.sandBoxSearch.is_cloned === '2';
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      if (this.sandBoxSearch.update_time) {
        params.update_time_begin = timestampToISO(this.sandBoxSearch.update_time[0]);
        params.update_time_end = timestampToISO(this.sandBoxSearch.update_time[1]);
      }
      return this.$request({
        url: this.$api.getSandbox,
        data: {
          offset: (pageIndex - 1) * pageSize,
          limit: pageSize,
          ...params,
        },
      }).then((res) => {
        const computedList = res.list.map((item) => ({
          ...item,
          cloned: item.is_cloned,
          is_cloned: item.is_cloned ? '是' : '否',
          update_time: formattedDate(isoToTimestamp(item.update_time)),
        }));

        return {
          list: computedList,
          total: Number(res?.total_count) || 0,
        };
      });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.sandBoxSearch = {
        sandbox_name: '',
        sandbox_type: '',
        sandbox_tmpl_name: '',
        is_cloned: '',
        update_by: '',
        update_time: '',
      };
      this.refresh();
    },
    // 增删改
    add() {
      this.operateType = 'add';
      this.createVisible = true;
    },
    edit(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    editFromDetail(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    refreshSandbox(row) {
      this.$request({
        url: this.$api.refreshSandbox,
        data: {
          tenant_id: row.id,
        },
      }).then(() => {
        this.$message({
          message:
            row.sandbox_type === 'development'
              ? '预计在1-5分钟后开始执行刷新任务'
              : '将在明天的上午0-6点执行刷新任务',
          type: 'success',
        });
      });
    },
    clone(row) {
      this.cloneVisible = true;

      this.cloneSandbox = {
        id: row.id, // 克隆的沙箱租户ID。必录
        name: '',
      };
    },
    toClone() {
      this.$refs.cloneForm.validate((valid) => {
        if (valid) {
          this.$refs.messageBox.show({
            title: '提示',
            content: '确定克隆吗?',
            titleIconType: 'warning',
            exitButton: true,
            needCancel: true,
            cancelAction: this.$refs.messageBox.close,
            confirmAction: () => {
              this.$request({
                url: this.$api.cloneSandbox,
                data: {
                  source_tenant_id: Number(this.cloneSandbox.id), // 克隆的沙箱租户ID。必录
                  name: this.cloneSandbox.name, // 本沙箱名称。必录
                },
              })
                .then(() => {
                  this.$refs.messageBox.close();
                  this.refresh();
                  this.cloneVisible = false;
                })
                .catch((err) => {
                  //  err
                  console.log('%c Line:329 🌮 err', 'color:#b03734', err);
                });
            },
          });
        } else {
          console.log('表单验证失败!');
          return false;
        }
      });
    },
    toDelete({ id }) {
      console.log(id);
      this.$message({
        message: '此功能暂无',
        type: 'warning',
      });
      // this.$refs.messageBox.show({
      //   title: '提示',
      //   content: '确定将该条sandbox信息从sandbox列表上删除？',
      //   titleIconType: 'warning',
      //   exitButton: true,
      //   needCancel: true,
      //   cancelAction: this.$refs.messageBox.close,
      //   confirmAction: () => {
      //     this.$request({
      //       url: this.$api.deleteEditProcess,
      //       data: { id },
      //       cb: () => {
      //         this.$refs.messageBox.close();
      //         this.refresh();
      //       },
      //     });
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';

.container {
  display: flex;
  flex-direction: column;
}
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
.table-container {
  flex: 1;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
  .table-action-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    .table-action-form {
      flex: 1;
      display: flex;
      flex-flow: wrap;
      .form-item {
        width: 240px;
        margin-right: 18px;
      }
    }
  }
  .text-button {
    margin-right: 15px;
  }
  .danger-action {
    color: #e34d59;
  }
}
.form-item {
  width: 240px;
  margin-right: 18px;
  ::v-deep .cell {
    height: 30px;
  }
}
.time_css {
  min-width: 410px;
  margin-right: 18px;
  height: 32px;
  ::v-deep .el-input__inner {
    padding-left: 30px;
  }
  ::v-deep .el-range__icon {
    line-height: 24px;
  }
  ::v-deep .el-range-separator {
    line-height: 24px;
  }
  ::v-deep .el-range__close-icon {
    line-height: 24px;
  }
}
::v-deep .el-table .cell {
  // background-color: #e34d59;
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  -webkit-line-clamp: 3; /* 限制为3行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  line-height: 1.5; /* 行高 */
  max-height: 4.5em; /* 最大高度，3行 * 行高 */
}
</style>
